import toast from 'react-hot-toast';
import FormSearch from './form-search';
import {
  getDetailVesselReportExport,
  useQueryGetDetailVesselReport,
} from '@/api/queries/vessels';
import { useEffect, useState } from 'react';

import { HourMeter, Rpm, VesselHistory } from '@/types/api';

import WheelIcon from '@/assets/icons/wheel.svg';
import Tabs from '@/components/ui/tabs';
import DatatableWithTheme from '@/components/ui/datatableWIthTheme';
import LineChart from '@/components/ui/charts/LineChart';
import ShipLoading from '@/components/ui/loader/ShipLoading';
import { FileBarChart2, Download } from 'lucide-react';

type Props = {};

type filterForm = {
    vessel: string;
    startDate: string;
    endDate: string;
};
export default function DetailReportRpm({}: Props) {
  const [exporting, setExporting] = useState(false);
  const [exportProgress, setExportProgress] = useState(0);
  const [activeTab, setActiveTab] = useState<'rpm' | 'hourmeter'>('rpm');
  const [filter, setFilter] = useState<filterForm>({
    vessel: '',
    startDate: '',
    endDate: '',
  });

    const [timelineChart, setTimelineChart] = useState<any>({
        labels: [],
        datasets: [],
    });

    const {
        error: errorDetailVessel,
        isError: isErrorDetailVessel,
        data: dataDetailVessel,
        isLoading: isLoadingDetailVessel,
        isFetching: isFetchingDetailVessel,
        refetch,
    } = useQueryGetDetailVesselReport(filter.vessel, filter.startDate, filter.endDate, false, 'rpm');

    const onSearch = (value: filterForm) => {
        if (value.vessel === '' || value.vessel === null) {
            toast.error('Vessel is required', {
                position: 'top-center',
            });
            return;
        }

        if (value.startDate === '') {
            toast.error('Start Date is required', {
                position: 'top-center',
            });
            return;
        }

        if (value.endDate === '') {
            toast.error('End Date is required', {
                position: 'top-center',
            });
            return;
        }

        setFilter(value);
    };

    useEffect(() => {
        if (
            filter.vessel !== '' &&
            filter.vessel !== null &&
            filter.startDate !== '' &&
            filter.vessel !== null &&
            filter.endDate !== '' &&
            filter.endDate !== null
        ) {
            refetch();
        }
    }, [filter]);

    const columns = [
        {
            name: 'DATE',
            selector: (row: Rpm) => row.receive_date,
            sortable: true,
            width: 'auto',
        },
        {
            name: 'RPM 1',
            selector: (row: Rpm) => row.rpm1,
            sortable: true,
            width: 'auto',
        },
        {
            name: 'RPM 2',
            selector: (row: Rpm) => row.rpm2,
            sortable: true,
            width: 'auto',
        },
        {
            name: 'SPEED',
            selector: (row: Rpm) => row.speed,
            sortable: true,
            width: 'auto',
        },
        {
            name: 'FUEL 1',
            selector: (row: Rpm) => row.fuel1,
            sortable: true,
            width: 'auto',
        },
        {
            name: 'FUEL 2',
            selector: (row: Rpm) => row.fuel2,
            sortable: true,
            width: 'auto',
        },
        {
            name: 'FUEL AUX',
            selector: (row: Rpm) => row.fuel_aux,
            sortable: true,
            width: 'auto',
        },
    ];

  const columnsHourmeter = [
    {
      name: 'DATE',
      selector: (row: HourMeter) => row.date,
      sortable: true,
    },
    {
      name: 'Hourmeter 1',
      selector: (row: HourMeter) => `${parseFloat(row.hourmeter1).toFixed(2)} Hours`,
      sortable: true,
    },
    {
      name: 'Hourmeter 2',
      selector: (row: HourMeter) => `${parseFloat(row.hourmeter2).toFixed(2)} Hours`,
      sortable: true,
    },
  ];

    useEffect(() => {
        if (dataDetailVessel?.rpm) {
            const speed = dataDetailVessel?.rpm.map((item) => item.speed);
            const rpm1 = dataDetailVessel?.rpm.map((item) => item.rpm1);
            const rpm2 = dataDetailVessel?.rpm.map((item) => item.rpm2);
            const fuel1 = dataDetailVessel?.rpm.map((item) => item.fuel1);
            const fuel2 = dataDetailVessel?.rpm.map((item) => item.fuel2);
            const engine1_time = dataDetailVessel?.rpm.map((item) => item.engine1_time);
            const engine2_time = dataDetailVessel?.rpm.map((item) => item.engine2_time);
            const dataset = {
                labels: dataDetailVessel?.rpm.map((item) => item.receive_date),
                datasets: [
                    {
                        label: 'Speed',
                        data: speed,
                        fill: false,
                        backgroundColor: 'rgb(255, 99, 132)',
                        borderColor: 'rgba(255, 99, 132, 0.2)',
                    },
                    {
                        label: 'RPM 1',
                        data: rpm1,
                        fill: false,
                        backgroundColor: 'rgb(54, 162, 235)',
                        borderColor: 'rgba(54, 162, 235, 0.2)',
                    },
                    {
                        label: 'RPM 2',
                        data: rpm2,
                        fill: false,
                        backgroundColor: 'rgb(255, 205, 86)',
                        borderColor: 'rgba(255, 205, 86, 0.2)',
                    },
                    {
                        label: 'Fuel 1',
                        data: fuel1,
                        fill: false,
                        backgroundColor: 'rgb(75, 192, 192)',
                        borderColor: 'rgba(75, 192, 192, 0.2)',
                    },
                    {
                        label: 'Fuel 2',
                        data: fuel2,
                        fill: false,
                        backgroundColor: 'rgb(153, 102, 255)',
                        borderColor: 'rgba(153, 102, 255, 0.2)',
                    },
                    {
                        label: 'Hourmeter 1',
                        data: engine1_time,
                        fill: false,
                        backgroundColor: 'rgb(255, 159, 64)',
                        borderColor: 'rgba(255, 159, 64, 0.2)',
                    },
                    {
                        label: 'Hourmeter 2',
                        data: engine2_time,
                        fill: false,
                        backgroundColor: 'rgb(255, 99, 132)',
                        borderColor: 'rgba(255, 99, 132, 0.2)',
                    },
                ],
            };

      setTimelineChart(dataset);
    }
  }, [dataDetailVessel]);
  const handleExportPDF = async (reportType: any) => {
    try {
      setExporting(true);
      setExportProgress(0);
      const interval = setInterval(() => {
        setExportProgress((prev) => (prev >= 90 ? 90 : prev + 15));
      }, 500);

      const response = await getDetailVesselReportExport(
        filter.vessel,
        filter.startDate,
        filter.endDate,
        true,
        reportType,
        'pdf',
        'false',
      );

      clearInterval(interval);
      setExportProgress(100);

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `report-${filter.vessel}-${filter.startDate}-${filter.endDate}.pdf`,
      ); //or any other extension
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.error('Error exporting PDF:', error);
    } finally {
      setTimeout(() => {
        setExporting(false);
        setExportProgress(0);
      }, 500);
    }
  };

  const handleExportXLSX = async (reportType: any) => {
    try {
      setExporting(true);
      setExportProgress(0);
      const interval = setInterval(() => {
        setExportProgress((prev) => (prev >= 90 ? 90 : prev + 15));
      }, 500);

      const response = await getDetailVesselReportExport(
        filter.vessel,
        filter.startDate,
        filter.endDate,
        true,
        reportType,
        'xlsx',
        'false',
      );

      clearInterval(interval);
      setExportProgress(100);

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `report-${filter.vessel}-${filter.startDate}-${filter.endDate}.xlsx`;
      link.click();
    } catch (error) {
      console.error('Error exporting xlsx:', error);
    } finally {
      setTimeout(() => {
        setExporting(false);
        setExportProgress(0);
      }, 500);
    }
  };

  return (
    <div className="space-y-6 relative">
      {isFetchingDetailVessel && (
        <ShipLoading label="Loading data rpm..." fullScreen={true} />
      )}
      {exporting && (
        <ShipLoading 
          label="Mengekspor laporan..." 
          showProgress={true} 
          progress={exportProgress} 
          fullScreen={true} 
        />
      )}
      <div className="relative overflow-hidden rounded-2xl border border-gray-200 dark:border-gray-800 bg-gradient-to-r from-brand-600 to-brand-500 text-white shadow-sm">
        <div
          className="absolute inset-0 opacity-20 pointer-events-none"
          style={{
            backgroundImage:
              "radial-gradient(circle at 20% 20%, rgba(255,255,255,.45), transparent 40%), radial-gradient(circle at 80% 80%, rgba(255,255,255,.25), transparent 45%)",
          }}
        />
        <div className="relative p-4 sm:p-6 grid grid-cols-[minmax(0,1fr)_auto] items-center gap-3 sm:flex sm:flex-wrap sm:justify-between">
          <div className="flex min-w-0 items-center gap-3 sm:gap-4">
            <div className="h-10 w-10 sm:h-12 sm:w-12 shrink-0 rounded-2xl bg-white/15 backdrop-blur flex items-center justify-center ring-1 ring-white/25">
              <FileBarChart2 className="h-5 w-5 sm:h-6 sm:w-6" />
            </div>
            <div className="min-w-0">
              <div className="text-[10px] sm:text-xs uppercase tracking-[0.18em] text-white/70 font-semibold mb-1">
                Fleet intelligence
              </div>
              <h1 className="text-lg sm:text-2xl font-bold tracking-tight truncate">
                RPM & Hourmeter Report
              </h1>
              <p className="hidden sm:block text-sm text-white/80 mt-1 max-w-xl">
                Detailed engine performance, fuel usage, and hourmeter tracking.
              </p>
            </div>
          </div>
          
          <div className="flex items-center gap-2 sm:gap-3">
            <button
              onClick={() => handleExportPDF(activeTab)}
              disabled={exporting || (activeTab === 'rpm' ? !((dataDetailVessel?.rpm?.length ?? 0) > 0) : !((dataDetailVessel?.hourmeter?.length ?? 0) > 0))}
              aria-label="Export PDF"
              className="h-9 w-9 sm:h-10 sm:w-auto sm:px-4 shrink-0 rounded-xl bg-white/15 hover:bg-white/25 backdrop-blur ring-1 ring-white/25 text-sm font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-50 transition-colors"
            >
              {exporting ? <span className="h-4 w-4 border-2 border-white/30 border-t-white rounded-full animate-spin" /> : <Download className="h-4 w-4" />}
              <span className="hidden sm:inline">Export PDF</span>
            </button>
            <button
              onClick={() => handleExportXLSX(activeTab)}
              disabled={exporting || (activeTab === 'rpm' ? !((dataDetailVessel?.rpm?.length ?? 0) > 0) : !((dataDetailVessel?.hourmeter?.length ?? 0) > 0))}
              aria-label="Export Excel"
              className="h-9 w-9 sm:h-10 sm:w-auto sm:px-4 shrink-0 rounded-xl bg-white/15 hover:bg-white/25 backdrop-blur ring-1 ring-white/25 text-sm font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-50 transition-colors"
            >
              {exporting ? <span className="h-4 w-4 border-2 border-white/30 border-t-white rounded-full animate-spin" /> : <Download className="h-4 w-4" />}
              <span className="hidden sm:inline">Export Excel</span>
            </button>
          </div>
        </div>
      </div>

      <FormSearch onSearch={onSearch} type="rpm" />

      <div className="bg-white dark:bg-gray-900 border border-gray-100 dark:border-gray-800 shadow-sm rounded-2xl p-4 sm:p-6 overflow-x-auto">
        <Tabs>
          <Tabs.MenuGroup>
            <Tabs.Menu index={0} title={'RPM'} onChange={() => setActiveTab('rpm')} />
            <Tabs.Menu index={1} title={'Hourmeter'} onChange={() => setActiveTab('hourmeter')} />
            <Tabs.Menu index={2} title={'Chart'} />
          </Tabs.MenuGroup>
          <Tabs.PanelGroup>
            <Tabs.Panel index={0}>
              <DatatableWithTheme
                columns={columns}
                progressPending={isLoadingDetailVessel || isFetchingDetailVessel}
                progressComponent={<WheelIcon className="animate-spin h-10 w-10" />}
                data={dataDetailVessel?.rpm || []}
                paginationPerPage={10}
                pagination
              />
            </Tabs.Panel>
            <Tabs.Panel index={1}>
              <DatatableWithTheme
                columns={columnsHourmeter}
                progressPending={isLoadingDetailVessel || isFetchingDetailVessel}
                progressComponent={<WheelIcon className="animate-spin h-10 w-10" />}
                data={dataDetailVessel?.hourmeter || []}
                paginationPerPage={10}
                pagination
              />
            </Tabs.Panel>
            <Tabs.Panel index={2}>
              <LineChart
                title={`Report Vessel History RPm ${filter.vessel}`}
                datasets={timelineChart}
              />
            </Tabs.Panel>
          </Tabs.PanelGroup>
        </Tabs>
      </div>
    </div>
  );
}
